import { UPDATE_TEXT } from '../actions/types';

const initialState = 'enter your text here';

export default function(state = initialState, action) {
  switch (action.type) {
    case UPDATE_TEXT:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/textReducer.js